import styled from '@emotion/styled';

const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexGrow: 999,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.eclipseTier1.spacing['8px'],
}));

export const S = {
  Content,
} as const;
